import { useEffect, useId, useRef, useState } from 'react';

/**
 * "Investigation Unit이란?" 팝오버.
 * 자세히 보기를 누르면 팝오버를 닫고 상세 모달로 넘긴다.
 *
 * @param {object} props
 * @param {() => void} props.onOpenDetail
 * @param {{current: HTMLElement|null}} props.triggerRef 모달이 닫힐 때 포커스를 돌려줄 버튼
 */
export function UnitPopover({ onOpenDetail, triggerRef }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const panelId = useId();
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const onDocumentClick = (event) => {
      if (wrapRef.current?.contains(event.target)) return;
      setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      setOpen(false);
      triggerRef.current?.focus();
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, triggerRef]);

  return (
    <div ref={wrapRef} className="relative mt-6 inline-block">
      <button
        type="button"
        ref={triggerRef}
        aria-expanded={open}
        aria-controls={panelId}
        className="plan-info-btn"
        onClick={() => setOpen((prev) => !prev)}
      >
        Investigation Unit이란?
      </button>

      <div
        id={panelId}
        role="dialog"
        aria-labelledby={titleId}
        hidden={!open}
        className="popover-panel"
      >
        <h3
          id={titleId}
          className="text-[24px] leading-[1.4] font-semibold tracking-[-0.02em] text-fg-title"
        >
          Investigation Unit이란?
        </h3>
        <p className="mt-8 mb-[14px] text-[18px] leading-none font-bold text-[#7c43d2]">
          1 Investigation Unit = 1 investigation target Endpoint
        </p>
        <div className="flex items-end justify-between gap-6">
          <p className="text-[16px] leading-none font-medium text-fg-body">
            Server 1대 또는 이에 준하는 하나의 조사 대상
          </p>
          <button
            type="button"
            id="unitDetailBtn"
            className="shrink-0 cursor-pointer text-[16px] leading-none font-extrabold text-fg-body underline decoration-solid hover:text-brand-600"
            onClick={() => {
              setOpen(false);
              onOpenDetail();
            }}
          >
            자세히 보기
          </button>
        </div>
      </div>
    </div>
  );
}
